import { ReactElement } from 'react';
import '@assets/styles/pages/help-support.scss';
import { HelpAndSupport } from '@components/helpAndSupport/Support';

export const Support = (): ReactElement => {
	return <HelpAndSupport />;
};
